export default {
  name: 'calendarTimePicker',
  template:
    `<p class="text-center" ng-if="::!$ctrl.hideDate"><strong>{{$ctrl.date | date:'short'}}</strong></p>
    <br>
    <div uib-datepicker
         datepicker-options="$ctrl.options"
         ng-model="$ctrl.date"
         ng-change="$ctrl.dateChangeAction({ date: $ctrl.date });"
    >
    </div>
    <div uib-timepicker
         ng-hide="$ctrl.hideTimePicker"
         ng-model="$ctrl.date"
         hour-step="1"
         minute-step="5"
         show-meridian="true"
         readonly-input="false"
         ng-change="$ctrl.timeChangeAction();"
    >
    </div>`,
  bindings: {
    date: '=ngModel',
    options: '<',
    hideTimePicker: '<',
    dateChangeAction: '&',
    timeChangeAction: '&',
    hideDate: '=?'
  }
};
